var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{class:_vm.selectClass,attrs:{"id":_vm.id,"options":_vm.options,"label":_vm.selectLabel,"placeholder":_vm.placeholder,"value":_vm.value,"multiple":""},on:{"input":(role) => _vm.$emit('input', role)}})
}
var staticRenderFns = []

export { render, staticRenderFns }